import FilterContainer from './FilterContainer'
import { connect } from 'react-redux'
import ReduxActions from 'redux/actions'

const mapStateToProps = state => {
  return {
    regionsData: state.REGIONS.regionsData,
    referenceRegionsData: state.REGIONS.referenceRegionsData,
    selectedRegionId: state.REGIONS.selectedRegionId
  }
}

const mapDispatchToProps = dispatch => {
  return {
    manageAllFilter: checked => dispatch(ReduxActions.manageAllFilter(checked)),
    manageReferenceFilter: checked => dispatch(ReduxActions.manageReferenceFilter(checked)),
    manageSameCountryFilter: checked => dispatch(ReduxActions.manageSameCountryFilter(checked)),
    manageTypeAheadFilter: selected => dispatch(ReduxActions.manageTypeAheadFilter(selected)),
    manageEvolutionFilter: selected => dispatch(ReduxActions.manageEvolutionFilter(selected)),
    manageChartTypeFilter: selected => dispatch(ReduxActions.manageChartTypeFilter(selected))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterContainer)



// WEBPACK FOOTER //
// ./src/modules/Filters/FilterContainer/index.js